import {
  Avatar,
  Badge,
  List,
  Popover,
  Skeleton,
  Space,
  Typography,
} from "antd";
import { BellIcon } from "../../../components/Icons";
import "./NotifyHeader.scss";
import { formatTimeVN } from "../../../utils/formatTime/DateFormat";
import { useAppSelector } from "../../../redux/hooks";
import parse from "html-react-parser";
import { useNavigate } from "react-router-dom";

function NotifyHeader() {
  const navigate = useNavigate();

  const dataPosts = useAppSelector((state) => state.post);
  const posts = dataPosts.result;
  const handleDetailPost = (id: any) => {
    navigate(`/post-detail/${id}`);
  };
  return (
    <>
      <Popover
        title={<h3 className="title-popover">Thông báo</h3>}
        content={
          <List
            className="wrapper-popover-notify"
            loading={false}
            // bordered
            // pagination={{
            //   total: pagination?.total,
            //   current: page,
            //   pageSize: pagination?.per_page ?? DEFAULT_PAGE_SIZE,
            //   onChange: onChangePage,
            //   showSizeChanger: true,
            // }}
            itemLayout="horizontal"
            dataSource={posts?.length > 0 ? posts : []}
            renderItem={(item: any) => (
              <List.Item
                onClick={() => handleDetailPost(item._id)}
                className="cursor-pointer">
                <Skeleton avatar title={false} loading={item?.loading} active>
                  <List.Item.Meta
                    avatar={
                      <Avatar
                        style={{ width: 45, height: 45 }}
                        src={item?.image}
                      />
                    }
                    title={
                      <Space className="space-title-notify" size={12}>
                        <Typography className="title-notify">
                          {item?.title}
                        </Typography>
                      </Space>
                    }
                    description={
                      <>
                        <div className="container-description-notify">
                          <Typography className="text-description">
                            <span className="text-description-parse">
                              {parse(item?.description || "")}
                            </span>
                          </Typography>
                        </div>
                        <span className="title-time">
                          {formatTimeVN(item?.createdAt)}
                        </span>
                      </>
                    }
                  />
                </Skeleton>
              </List.Item>
            )}
          />
        }
        trigger="click">
        <Badge
          dot={true}
          style={{
            width: "10px",
            height: "10px",
            cursor: "pointer",
          }}>
          <BellIcon width="2rem" height="2rem" className="custom-ic-notify" />
        </Badge>
      </Popover>
    </>
  );
}

export default NotifyHeader;
